import React from 'react';
import { Box, Theme, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'services/localization';
import useShopFormat from 'hooks/useShopFormat';
import { ShopPublicInfo } from 'common/types';
import moment from 'moment-timezone';
interface Props {
	startDate: moment.Moment;
	endDate: moment.Moment;
	shopPublicInfo: ShopPublicInfo;
	shopLocationString: string | null;
}

const ReportInfo = ({ startDate, endDate, shopPublicInfo, shopLocationString }: Props) => {
	const { t } = useTranslation();
	const { localFormat } = useShopFormat();
	const classes = useStyles();
	const timeZoneOffset = moment().utcOffset();
	const timeZoneOffsetHours = Math.abs(timeZoneOffset) / 60;
	return (
		<Box className={classes.reportInfo}>
			<Typography variant="h6" gutterBottom>
				{t('reports.accounting.reportTitle', 'Rentle report for period')}:{' '}
				{localFormat(startDate!, 'DD.MM.YYYY')} - {localFormat(endDate!, 'DD.MM.YYYY')}{' '}
				{`(UTC ${timeZoneOffsetHours >= 0 ? '+' : '-'}${timeZoneOffsetHours})`}
			</Typography>
			<Typography>
				{t('common:company', 'Company')}: {shopPublicInfo.name}{' '}
				{!!shopPublicInfo.businessId && `(${shopPublicInfo.businessId})`}
			</Typography>
			{!!shopLocationString && (
				<Typography>
					{t('common:shopLocation.location')}: {shopLocationString}
				</Typography>
			)}
		</Box>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		reportInfo: {
			marginTop: theme.spacing(6),
			marginBottom: theme.spacing(2),
			'@media print': {
				marginTop: theme.spacing(0),
				padding: theme.spacing(0, 2),
			},
		},
	}),
);

export default ReportInfo;
